import moment, { Moment } from 'moment';

/** 展示时间默认范围：今天起 6 个月 */
export const getDefaultDisplayTimeRange = (): [Moment, Moment] => [
  moment().startOf('day'),
  moment().add(6, 'months').endOf('day'),
];
